"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["id"];
const _hoisted_2 = { class: "h-full flex items-center justify-start gap-2" };
const _hoisted_3 = { class: "flex flex-col grow items-start justify-center content-center whitespace-nowrap overflow-hidden" };
const _hoisted_4 = {
    key: 0,
    class: "text-xs"
};
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = ["id"];
const _hoisted_7 = ["onClick", "innerHTML"];
const vue_3 = require("vue");
const DropdownInputItem_1 = __importDefault(require("./DropdownInputItem"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'DropdownInput',
    props: {
        placeholder: {
            type: String,
            default: ''
        },
        items: {
            type: Array,
            default: []
        },
        modelValue: {
            type: [String, Number, () => null],
            default: null
        },
        disableDeselect: {
            type: Boolean,
            default: false
        }
    },
    emits: ["update:modelValue"],
    setup(__props, { emit }) {
        var _a;
        const props = __props;
        const dropdownItemsVisible = (0, vue_3.ref)(false);
        const componentId = (_a = (0, vue_3.getCurrentInstance)()) === null || _a === void 0 ? void 0 : _a.uid;
        const dropdown = (0, vue_3.ref)(null);
        const dropdownItems = (0, vue_3.ref)(null);
        const selectedItem = (0, vue_3.ref)(null);
        //TODO on long term the props.items shouldn't be Array<String>, just Array<DropdownInputItem>!
        const refinedItems = (0, vue_3.computed)(() => {
            return props.items.map((item) => {
                if (item instanceof DropdownInputItem_1.default) {
                    return item;
                }
                return new DropdownInputItem_1.default(String(item), String(item));
            });
        });
        const toggleDropdownItems = () => {
            dropdownItemsVisible.value = !dropdownItemsVisible.value;
            (0, vue_3.nextTick)(() => {
                dropdownItems.value = document.getElementById(`dropdown_items_${componentId}`);
            });
        };
        const clickOutsideListener = (event) => {
            if (dropdown.value !== null && !dropdown.value.contains(event.target)) {
                dropdownItemsVisible.value = false;
                return;
            }
        };
        (0, vue_3.onMounted)(() => {
            dropdown.value = document.getElementById(`dropdown_${componentId}`);
            document.addEventListener('click', clickOutsideListener);
        });
        (0, vue_3.onUnmounted)(() => {
            document.removeEventListener('click', clickOutsideListener);
        });
        const selectItem = (item, index) => {
            selectedItem.value = item;
            dropdownItemsVisible.value = false;
            emit("update:modelValue", item.value);
        };
        const deselect = () => {
            selectedItem.value = null;
            emit('update:modelValue', null);
        };
        const label = (0, vue_3.computed)(() => {
            if (props.modelValue === null) {
                return props.placeholder;
            }
            let selectedItem = refinedItems.value
                .find((item) => item.value === String(props.modelValue));
            return selectedItem === undefined ? props.placeholder : selectedItem.text;
        });
        return (_ctx, _cache) => {
            var _a;
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                id: `dropdown_${(0, vue_2.unref)(componentId)}`,
                class: (0, vue_2.normalizeClass)(["relative bg-gray p-2 cursor-pointer", {
                        'bg-gray opacity-70': ((_a = __props.items) === null || _a === void 0 ? void 0 : _a.length) === 0
                    }]),
                ref_key: "dropdown",
                ref: dropdown,
                onClick: toggleDropdownItems
            }, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (__props.disableDeselect && __props.modelValue !== null)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_4, (0, vue_2.toDisplayString)(__props.placeholder), 1))
                            : (0, vue_2.createCommentVNode)("", true),
                        (0, vue_2.createElementVNode)("div", {
                            class: (0, vue_2.normalizeClass)({ 'font-bold': __props.disableDeselect }),
                            innerHTML: label.value
                        }, null, 10, _hoisted_5)
                    ]),
                    ((selectedItem.value !== null || __props.modelValue !== null) && !__props.disableDeselect)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", {
                            key: 0,
                            class: "marso-icon-close text-xs lg:block ml-auto",
                            "aria-hidden": "true",
                            onClick: deselect
                        }))
                        : (0, vue_2.createCommentVNode)("", true),
                    (0, vue_2.createElementVNode)("i", {
                        class: (0, vue_2.normalizeClass)(["marso-icon-chevron-down transform-gpu transition-transform text-xs", {
                                'rotate-180': dropdownItemsVisible.value,
                                'ml-auto': __props.disableDeselect
                            }]),
                        "aria-hidden": "true"
                    }, null, 2)
                ]),
                (dropdownItemsVisible.value && props.items.length)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                        key: 0,
                        id: `dropdown_items_${(0, vue_2.unref)(componentId)}`,
                        class: (0, vue_2.normalizeClass)(["rounded-b-md absolute z-10 bg-white min-w-full left-0 top-full", {
                                'max-h-80': __props.items.length > 8,
                                'overflow-y-scroll': __props.items.length > 8
                            }])
                    }, [
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(refinedItems.value, (item, index) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                onClick: ($event) => (selectItem(item, index)),
                                class: (0, vue_2.normalizeClass)(["px-2 py-2 hover:bg-gray cursor-pointer", { 'bg-gray': __props.modelValue === item.value }]),
                                innerHTML: item.text
                            }, null, 10, _hoisted_7));
                        }), 256))
                    ], 10, _hoisted_6))
                    : (0, vue_2.createCommentVNode)("", true)
            ], 10, _hoisted_1));
        };
    }
});
